export interface PageResult<T> { items: T[]; total: number; page: number; limit: number; totalPages: number; }
export function readPage<T>(body: unknown, itemsKey = "data"): PageResult<T> {
  if (!body || typeof body !== "object") throw new Error("The server returned an invalid list response.");
  const raw = body as Record<string, any>;
  const items = raw[itemsKey];
  if (!Array.isArray(items)) throw new Error("The server returned an invalid list response.");
  const meta = raw.meta ?? raw.pagination ?? raw;
  const total = Number(meta.total ?? meta.totalItems ?? items.length);
  const page = Number(meta.page ?? meta.currentPage ?? 1);
  const limit = Number(meta.limit ?? 20);
  const totalPages = Number(meta.totalPages ?? Math.ceil(total / limit));
  if (![total, page, limit, totalPages].every(Number.isFinite) || total < 0 || page < 1 || limit < 1 || totalPages < 0) throw new Error("The server returned invalid pagination.");
  return { items, total, page, limit, totalPages };
}
